import {call, put} from "redux-saga/effects";
import {getPackageApi} from "../../../../common/apis/packageApi";
import * as actions from "../state/detailPackageActions";

export function* getDetailPackageSaga({ payload }) {
  try {
    const response = yield call(getPackageApi, payload);
    yield put(actions.getDetailPackageSuccessAction(response.data.body));
  } catch (error) {
    yield put(actions.getDetailPackageFailAction(error));
  }
}
